import moment from "moment";

const formatDatabaseDate = (date) => {
    if(!date){
        return 'unavailable';
    }
    return moment(date).format("DD/MM/YYYY HH:mm");
};

export default formatDatabaseDate;